import {
    Button,
    Heading,
    Icon,
    Select,
    SimpleGrid,
    Stack,
    StackDivider,
    Table,
    TableContainer,
    Tbody,
    Td,
    Text,
    Textarea,
    Th,
    Thead,
    Tr, 
    useToast,
    Checkbox,
} from "@chakra-ui/react";
import { useEffect, useState, useRef } from "react";
import {FaDownload, FaPlus,FaCheck} from "react-icons/fa";
import { RiSaveFill } from "react-icons/ri";
import { AiFillFileText } from "react-icons/ai";
import AddDocument from "../../components/Modals/AddDocument";
import { GET, GETFile, PUT } from "../../utils/ApiRequestProvider";
import { useSelector } from "react-redux";
import DocViewer, { DocViewerRef, DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { TagInput } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';

import { BASE_URL } from "config";

interface PaginationType {
    currentPage: number;
    totalPages: number;
    totalRecords: number;
}

interface FileViewerType {
    documentId: number;
    uri: string;
    fileName: string;
}

export default function OtherDocuments() {
    const [tagstodo, setTagstodo] = useState([]);
    const [isAddFileModalOpen, setIsAddFileModalOpen] = useState(false);
    const toast = useToast();
    const business = useSelector((state: any) => state.selections.value?.business);
    // const [selectedTab, setSelectedTab] = useState<string>("Uploaded");
    const [paginationQuery] = useState({ page: 1, pageSize: 10 });
    const [, setPagination] = useState<PaginationType>({ currentPage: 0, totalPages: 0, totalRecords: 0 });
    const [, setLoading] = useState(false);
    const [documents, setDocuments] = useState<any[]>([]);
    const [selectedDocuments, setSelectedDocuments] = useState<Array<any>>([]);
    const [selectedDocument, setSelectedDocument] = useState<any>({});
    const [selectedDocumentPDF, setSelectedDocumentPDF] = useState<FileViewerType[]>([]);
    const [Notes, setNotes] = useState<string>("");
    const [DocType, setDocType] = useState<string>("");
    const docViewerRef = useRef<DocViewerRef>(null);

    const handleTagAddClick = (e: any) => {
        setTagstodo(e);
    }

    const onAddFileModalClose = async () => {
        setIsAddFileModalOpen(false);
    }

    const  FetchList = async () => {
        setLoading(true);
        try {
            if (business) {
                const res = await GET(`/api/Documents/${business?.id}/OtherDocuments/list?page=${paginationQuery.page}&pageSize=${paginationQuery.pageSize}&status=&sortColumn=Date&sortOrder=desc`);
                setPagination(res.data.pagination);
                setDocuments(res.data.documents);
                toast({
                    title: 'Data Fetched',
                    description: 'Data has been fetched successfully!',
                    status: 'success',
                    isClosable: false,
                    duration: 1000,
                    position: 'top-right'
                });
            }
        } catch (err) {
            toast({
                title: 'Something Went Wrong!',
                description: 'An unexpected error occured while proceeding your request!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
        }
        setLoading(false);
    }

    const handleSelectedDocument = async (e: any) => {
        if (e.target.checked) {
            // console.log(e.target.id);
            const id = parseInt(e.target.id);
            setSelectedDocuments([...selectedDocuments, e.target.id]);
            // console.log(documents.filter(doc => doc.id === id));
            setSelectedDocument(documents.filter(doc => doc.id === id));
        } else {
            setSelectedDocuments(selectedDocuments.filter((doc) => doc !== e.target.id));
            setSelectedDocument({});
        }
    }

    const getFilePDF = async () => {
        try {
            if(selectedDocument[0]?.file === undefined || selectedDocument[0]?.file === null){
                setSelectedDocumentPDF([]);
                return;
            }
            if(selectedDocumentPDF.find(doc => doc.documentId === selectedDocument[0]?.id) !== undefined){
                return;
            }
            const file = await GETFile(selectedDocument[0]?.file);
            setSelectedDocumentPDF([...selectedDocumentPDF, { documentId: selectedDocument[0]?.id, uri: URL.createObjectURL(file), fileName: file.name }]);
        } catch (err) {
            toast({
                title: 'Something Went Wrong!',
                description: 'An unexpected error occured while proceeding your request!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
        }
    }

    const handleSetNotes = async (e: any) => {
        setNotes(e.target.value);
    }

    const handleSetDocType = async (e: any) => {
        setDocType(e.target.value);
    }

    const handleSaveDocument = async () => {
        try {
            var arr_to_update : any = {};
            // console.log(tagstodo.join(","));
            // {
            //     "supplierId": "3",
            //     "invoiceDate": "2024-04-30",
            //     "dueDate": "2024-04-30",
            //     "invoiceNumber": "6",
            //     "categoryId": 0,
            //     "vatGstRateId": 1,
            //     "vatGstRateValue": 10,
            //     "paymentMethodId": 0,
            //     "grossAmount": "1511",
            //     "vatAmount": "137.36",
            //     "netAmount": 1373.64,
            //     "transactionCurrencyId": 7,
            //     "baseCurrency": "AUD",
            //     "exchangeRate": 0.654,
            //     "convertedGrossAmount": 988.19,
            //     "convertedVATAmount": 89.84,
            //     "convertedNetAmount": 898.36,
            //     "description": "tet",
            //     "additionalOptions": null,
            //     "dataEntryOperatorId": 1,
            //     "isSave": true
            // }
            arr_to_update["isSave"] = true;
            arr_to_update["supplierId"] = "0";
            arr_to_update["status"] = "Uploaded";
            arr_to_update["invoiceDate"] = "2024-04-30";
            arr_to_update["dueDate"] = "2024-04-30";
            arr_to_update["vatGstRateId"] = 0;
            arr_to_update["vatGstRateValue"] = 0;
            arr_to_update["paymentMethodId"] = 0;
            arr_to_update["grossAmount"] = "0";
            arr_to_update["vatAmount"] = "0";
            arr_to_update["netAmount"] = 0;
            arr_to_update["transactionCurrencyId"] = 0;
            arr_to_update["exchangeRate"] = 0;
            arr_to_update["convertedGrossAmount"] = 0;
            arr_to_update["convertedVATAmount"] = 0;
            arr_to_update["convertedNetAmount"] = 0;
            arr_to_update["additionalOptions"] = null;
            arr_to_update["dataEntryOperatorId"] = 1;
            arr_to_update["categoryId"] = 0;
            arr_to_update["baseCurrency"] = "AUD";
            arr_to_update["description"] = "tet";

            if(tagstodo.length > 0){
                arr_to_update["tags"] =tagstodo.join(",");
            }
            if(Notes !== ""){
                arr_to_update["notes"] = Notes;
            }
            if(DocType !== ""){
                arr_to_update["documentType"] = DocType;
            }

            console.log(arr_to_update);
            const res = await PUT(`/api/Documents/save/${selectedDocument[0].id}`, arr_to_update);
            if (res.status === "success") {
                toast({
                    title: 'Document Updated',
                    description: 'Document has been updated successfully!',
                    status: 'success',
                    isClosable: false,
                    duration: 1000,
                    position: 'top-right'
                });
                FetchList();
            }
        } catch (err) {
            toast({
                title: 'Something Went Wrong!',
                description: 'An unexpected error occured while proceeding your request!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
        }
    }

    const DownloadFile = async () => {
        if(selectedDocument.length === 0 || selectedDocument.length === undefined){
            toast({
                title: 'No Document Selected!',
                description: 'Please select a document to download!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
            return;
        }
        if(selectedDocument[0].dataFile === ""){
            toast({
                title: 'No File Found!',
                description: 'No file found for this document!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
            return;
        }
        const url = BASE_URL + selectedDocument[0].dataFile;
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', selectedDocument[0].dataFile.split('/')[selectedDocument[0].dataFile.split('/').length - 1]);
        document.body.appendChild(link);
        link.click();
        toast({
            title: 'File Downloaded!',
            description: 'File has been downloaded successfully!',
            status: 'success',
            isClosable: false,
            duration: 1000,
            position: 'top-right'
        });
    }

    const ApproveDocument = async () => {
        if(selectedDocuments.length === 0 || selectedDocuments.length === undefined){
            toast({
                title: 'No Document Selected!',
                description: 'Please select a document to approve!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
            return;
        }
        var arr_ids : any[] = [];
            selectedDocuments.forEach((item) =>{
                arr_ids.push(item);
            });
        var arr_to_reclassify = {"documents_ids": arr_ids, "status": "Exported"};
        const response = await PUT(`/api/documents/exported`, arr_to_reclassify);
        if(response.status === "success"){
            toast({
                title: 'Document Approved!',
                description: 'Document has been approved successfully!',
                status: 'success',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
        }
        FetchList();
    }

    useEffect(() => {
        // console.log(selectedDocument);
        if (selectedDocument.length > 0) {
            // debugger;
            if(selectedDocument[0]?.tags !== undefined && selectedDocument[0]?.tags !== null && selectedDocument[0]?.tags !== ""){
                setTagstodo(selectedDocument[0]?.tags.split(","));
            }
        }
        getFilePDF();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedDocument]);

    useEffect(() => {
        FetchList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [business, paginationQuery]);

    return (
        <Stack w={'full'} justify={"center"} align={"center"} spacing={6}>
            <Stack
                direction={{ base: 'column', md: 'column', lg: 'column', xl: 'column', "2xl": "row" }}
                justify={'space-between'}
                boxShadow={'base'}
                rounded={'xl'}
                w={'98%'}
                p={4}
                spacing={{ base: 6, md: 6, lg: 6, xl: 6, "2xl": 0 }}
            >
                <Stack
                    align={'flex-start'}
                    justify={'start'}
                    spacing={4}
                >
                    <Stack direction={'row'}>
                        <Icon
                            as={AiFillFileText}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={1}>
                            <Heading fontSize={'xl'}>Other Documents</Heading>
                            <Text fontSize={'sm'}>Here you can see all your other documents</Text>
                        </Stack>
                    </Stack>
                </Stack>
                <Stack align={{ lg: 'flex-start', "2xl": 'flex-end' }} direction={'row'} spacing={4}>
                    <Button
                        size={'sm'}
                        leftIcon={<FaPlus />}
                        color={'white'}
                        bg={'primary.400'}
                        _hover={{ bg: 'primary.400' }}
                        _active={{ bg: 'primary.400' }}
                        w={'120px'}
                        onClick={() => setIsAddFileModalOpen(true)}
                    >
                        Add Files
                    </Button>
                </Stack>
            </Stack>

            <Stack boxShadow={'base'} rounded={'xl'} w={'98%'} p={4} spacing={4}>
                <SimpleGrid
                    templateColumns={{ base: '1fr', md: '1fr 4fr 2fr' }}
                    spacing={6}
                >
                    <Stack w={'250px'}>
                        <TableContainer>
                            <Table size='sm'>
                                <Thead h={'50px'} bg={'primary.400'} alignItems={'flex-start'}>
                                    <Tr>
                                        <Th
                                            color={'white'}
                                        >
                                            Doc ID
                                        </Th>
                                        <Th
                                            color={'white'}
                                        >
                                            Source
                                        </Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {
                                        documents.length > 0 ?
                                        documents.map((doc, index) => (
                                            <Tr key={index}>
                                                <Td display={'flex'} justifyContent={'space-between'}>
                                                    <Checkbox id={doc?.id} onChange={handleSelectedDocument} />
                                                    {doc?.id}</Td>
                                                <Td>{doc?.source}</Td>
                                            </Tr>
                                        )) :
                                        <Tr>
                                            <Td colSpan={2}>No data found</Td>
                                        </Tr>
                                    }
                                </Tbody>
                            </Table>
                        </TableContainer>
                    </Stack>
                    <Stack>
                        <Stack w={'full'} h={'full'} align={'center'} justify={'center'} textAlign={'center'} bg={'gray.500'}>
                            {/* <Heading color={'white'}>PDF Viewer Here</Heading> */}
                            {
                                selectedDocumentPDF.length > 0 ?
                                    <DocViewer
                                        ref={docViewerRef}
                                        pluginRenderers={DocViewerRenderers}
                                        documents={selectedDocumentPDF}
                                        config={{
                                            // header: {
                                            //     overrideComponent: DocumentHeader,
                                            // },
                                            csvDelimiter: ",",
                                            pdfZoom: {
                                                defaultZoom: 1.1,
                                                zoomJump: 0.2,
                                            },
                                            pdfVerticalScrollByDefault: true,
                                        }}
                                        style={{ overflowY: 'auto' }}
                                        theme={{
                                            primary: "#ffffffeb",
                                            secondary: "#ffffff",
                                            tertiary: "#05445d",
                                            textPrimary: "#000000",
                                            textSecondary: "#ffffff",
                                            textTertiary: "#ffffff",
                                        }}
                                    />
                                    : <>
                                        <Heading color={'white'}>Document Viewer</Heading>
                                        <Text color={'whiteAlpha.900'} padding={'0 10px'}>No Documents Selected! Select Any Document To Preview Here.</Text>
                                    </>
                            }
                        </Stack>
                    </Stack>
                    <Stack w={'full'} spacing={6} divider={<StackDivider />}>
                        <Stack spacing={4}>
                            <TagInput
                                block
                                placeholder="Enter tags"
                                style={{ width: '100%' }}
                                menuStyle={{ width: 300 }}
                                onChange={handleTagAddClick}
                                defaultValue={tagstodo}
                                value={tagstodo}
                            />

                            <Select placeholder='Select Document Type' onChange={handleSetDocType}>
                                <option key="1" value='PurchaseInvoice'>Purchase Invoice</option>
                                <option key="2" value='SalesInvoice'>Sales Invoice</option>
                                <option key="3" value='BankStatement'>Bank Statement</option>
                            </Select>

                            <Textarea
                                placeholder='Notes'
                                size='sm'
                                resize={'none'}
                                overflowY={'scroll'}
                                h={'36'}
                                p={3}
                                rounded={'lg'}
                                maxLength={250}
                                onChange={handleSetNotes}
                                defaultValue={selectedDocument[0]?.notes}
                            />

                            <Button
                                size={'sm'}
                                leftIcon={<RiSaveFill />}
                                color={'white'}
                                bg={'primary.400'}
                                _hover={{ bg: 'primary.400' }}
                                _active={{ bg: 'primary.400' }}
                                onClick={handleSaveDocument}
                            >
                                Save
                            </Button>
                        </Stack>
                        <Stack w={'full'}
                                display={(selectedDocument.length > 0 && (selectedDocument[0].status === "Data Entered" || selectedDocument[0].status === "Exported")) ? (selectedDocument[0].dataFile !== "" ? 'block' : 'none')  : 'none'}
                                >
                                <Button
                                    size={'sm'}
                                    ml={'5px !important'}
                                    mt={'4px !important'}
                                    color={'white'}
                                    bg={'blue.400'}
                                    leftIcon={<FaDownload />}
                                    _hover={{ bg: 'red.500' }}
                                    _active={{ bg: 'red.600' }}
                                    onClick={DownloadFile}>Download File</Button>
                                
                                <Button 
                                display={(selectedDocument.length > 0 && selectedDocument[0].status === "Data Entered") ? 'block' : 'none'}
                                ml={'5px !important'}
                                    mt={'4px !important'}
                                    size={'sm'}
                                    color={'white'}
                                    bg={'blue.400'}
                                    leftIcon={<FaCheck />}
                                    _hover={{ bg: 'red.500' }}
                                    _active={{ bg: 'red.600' }}
                                    onClick={ApproveDocument}
                                >
                                    Approve Document
                                </Button>
                        </Stack>
                        <Stack spacing={4}>
                            <Heading fontSize={'lg'}>Document Properties</Heading>
                            <Text>Document Id: <strong>{selectedDocument[0]?.id}</strong></Text>
                            <Text>Status: <strong>{selectedDocument[0]?.status}</strong></Text>
                            <Text>Uploaded By: <strong>{selectedDocument[0]?.user?.fullName ?? selectedDocument[0]?.uploader?.fullName ?? selectedDocument[0]?.uploader?.full_name ?? ''}</strong></Text>
                            <Text>Upload Date: <strong>{selectedDocument[0]?.createdAt}</strong></Text>
                            <Text>Source: <strong>{selectedDocument[0]?.source}</strong></Text>
                        </Stack>
                    </Stack>
                </SimpleGrid>
            </Stack>
            <AddDocument isOpen={isAddFileModalOpen} onClose={onAddFileModalClose} DocType={"Other Documents"} RefreshList={FetchList} />
        </Stack >
    )
}